import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdMeetingRoom, MdCheck } from "react-icons/md";
import Model from "../Model";
import Config from "../../Config";

const DeleteRoomModal = ({
  setDeleteRoomModal,
  selectedData,
  deleteRoomMutate,
  deleteLoading,
}) => {
  console.log("LOKD", selectedData);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const { roomStatus, roomStatusStyle } = Config;

  const toggleRoomSelection = (roomId) => {
    setSelectedRooms((prev) =>
      prev.includes(roomId)
        ? prev.filter((id) => id !== roomId)
        : [...prev, roomId],
    );
  };

  const handleDelete = () => {
    if (selectedRooms.length === 0) return;

    deleteRoomMutate({
      roomId: selectedRooms,
    });
  };

  const getStatus = (status) => {
    return {
      text: roomStatus[status] || "Unknown",
      style:
        roomStatusStyle[status] ||
        "bg-slate-100 text-slate-600 border-slate-300",
    };
  };

  return (
    <Model
      width={`w-11/12 max-w-lg`}
      setOpenModel={setDeleteRoomModal}
      title="Delete Rooms"
    >
      <Wrapper>
        <TopSection>
          <div>
            <Title>Delete Rooms</Title>
            <SubTitle>
              Choose the vacant rooms you want to delete.
            </SubTitle>
          </div>

          <SelectedCount>{selectedRooms.length} Selected</SelectedCount>
        </TopSection>

        {selectedData && (
          <FlatCard key={selectedData.flatId}>
            <FlatHeader>
              <div>
                <FlatTitle>Flat {selectedData.flatName}</FlatTitle>

                <FlatSubTitle>
                  {selectedData.rooms.length} Rooms Available
                </FlatSubTitle>
              </div>
            </FlatHeader>

            <RoomGrid>
              {selectedData.rooms.map((room) => {
                const isSelected = selectedRooms.includes(room.roomId);

                const statusData = getStatus(room.status);

                const isVacant = room.status === 1;

                return (
                  <RoomCard
                    key={room.roomId}
                    onClick={() => isVacant && toggleRoomSelection(room.roomId)}
                    className={
                      isSelected
                        ? "border-red-400 bg-red-50 shadow-lg scale-[1.02]"
                        : !isVacant
                          ? "opacity-60 cursor-not-allowed bg-gray-100"
                          : ""
                    }
                  >
                    <RoomTop>
                      <RoomIcon
                        className={
                          isSelected
                            ? "bg-red-500 text-white"
                            : !isVacant
                              ? "bg-gray-200 text-gray-400"
                              : "bg-slate-100 text-slate-600"
                        }
                      >
                        {isSelected ? (
                          <MdCheck size={12} />
                        ) : (
                          <MdMeetingRoom size={12} />
                        )}
                      </RoomIcon>

                      {isVacant && (
                        <SelectCircle
                          className={
                            isSelected ? "bg-red-500 border-red-500" : ""
                          }
                        >
                          {isSelected && <MdCheck size={12} />}
                        </SelectCircle>
                      )}
                    </RoomTop>

                    <RoomContent>
                      <RoomNumber>Room {room.roomNum}</RoomNumber>

                      <RoomId>Room ID : {room.roomId}</RoomId>

                      <StatusBadge className={statusData.style}>
                        {statusData.text}
                      </StatusBadge>

                      {/* {!isVacant && <BlockedText>Cannot Delete</BlockedText>} */}
                    </RoomContent>
                  </RoomCard>
                );
              })}
            </RoomGrid>
          </FlatCard>
        )}

        <Footer>
          <CancelBtn onClick={() => setDeleteRoomModal(false)}>
            Close
          </CancelBtn>

          <DeleteBtn
            onClick={handleDelete}
            disabled={selectedRooms.length === 0 || deleteLoading}
          >
            {deleteLoading
              ? "Deleting..."
              : `Delete`}
          </DeleteBtn>
        </Footer>
      </Wrapper>
    </Model>
  );
};

const Wrapper = tw.div`
flex flex-col gap-5
px-1
`;

const TopSection = tw.div`
flex items-center justify-between
border-b border-gray-200
pb-2
`;

const Title = tw.h2`
text-xl
font-bold
text-gray-800
`;

const SubTitle = tw.p`
text-xs
text-gray-500
mt-1
`;

const SelectedCount = tw.div`
px-4 py-2
rounded-full
bg-red-50
text-red-600
text-sm
font-semibold
border border-red-200
mt-6
`;

const FlatCard = tw.div`
bg-white
border border-gray-200
rounded-xl
p-4
shadow-sm
max-h-[54vh]
overflow-y-auto
pr-2
`;
const FlatHeader = tw.div`
flex items-center justify-between
mb-4
`;

const FlatTitle = tw.h3`
text-lg
font-bold
text-gray-800
`;

const FlatSubTitle = tw.p`
text-xs
text-gray-500
mt-1
`;

const RoomGrid = tw.div`
grid
grid-cols-2
sm:grid-cols-3
md:grid-cols-4
gap-2
`;
const RoomCard = tw.div`
relative
border border-slate-200
rounded-2xl
px-2.5
py-2
cursor-pointer
transition-all
duration-300
bg-white/90
backdrop-blur-sm
hover:shadow-lg
hover:border-slate-300
min-h-[96px]
flex
flex-col
justify-between
`;
const RoomTop = tw.div`
flex items-center justify-between
`;
const RoomIcon = tw.div`
w-6 h-6
rounded-lg
flex items-center justify-center
transition-all
text-[11px]
`;
const SelectCircle = tw.div`
w-4 h-4
rounded-full
border border-gray-300
flex items-center justify-center
text-white
transition-all
`;
const RoomContent = tw.div`
mt-2
`;
const RoomNumber = tw.h4`
text-[12px]
font-semibold
text-slate-800
leading-none
`;
const RoomId = tw.p`
text-[9px]
text-slate-400
mt-1
`;
const StatusBadge = tw.div`
inline-flex
items-center
mt-2
px-2
py-[2px]
rounded-full
text-[8px]
font-semibold
border
tracking-wide
`;

const BlockedText = tw.p`
text-[8px]
text-red-500
font-medium
mt-1
tracking-wide
`;

const Footer = tw.div`
sticky bottom-0
bg-white
flex items-center justify-between gap-3
`;


const CancelBtn = tw.button`
bg-slate-500 hover:bg-slate-600
flex items-center gap-2
px-5
h-11
rounded-xl
border border-gray-300
text-white
font-medium
transition-all
`;

const DeleteBtn = tw.button`
flex items-center gap-2
px-5
h-11
rounded-xl
bg-red-500
text-white
font-medium
hover:bg-red-600
transition-all
disabled:opacity-50
disabled:cursor-not-allowed
`;



export default DeleteRoomModal;
